export default __webpack_public_path__ + "static/media/guide5.4f25a2c3.jpg";